<template>
    <wo-pill v-if="value" :mod-error="modError" :mod-success="modSuccess" :mod-warning="modWarning" mod-xs class="wo-pill--sm">
      <po-display :value="value" />
    </wo-pill>
</template>

<script>

import _ from 'lodash'

export default {
  name: 'PoStatusBadge',
  props: {
    value: [String, Object],
    success: undefined,
    warning: undefined,
    error: undefined
  },
  computed: {
    modError () {
      return this.contains(this.error, this.value)
    },
    modSuccess () {
      return this.contains(this.success, this.value)
    },
    modWarning () {
      return this.contains(this.warning, this.value)
    }
  },
  methods: {
    contains (list, status) {
      return _.isArray(list) ? _.some(list, s => this.matches(s, status)) : this.matches(list, status)
    },
    matches (status, value) {
      return status && (status === value || status.id === value)
    }
  }
}
</script>
